import { Outlet } from "react-router-dom";
import { useAuthStore } from "../../stores/authStore";
import CabinetLayout from "./cabinetLayout";
import EmailNotConfirmed from "./emailNotConfirmed";
import LoadingIndicator from "../common/loadingIndicator";
import { useTranslation } from "react-i18next";

function Cabinet() {
  const {isEmailConfirmed, email} = useAuthStore();
  const { t } = useTranslation();  

  return (
    <>
      <CabinetLayout>
        {isEmailConfirmed && <Outlet />}
        {!isEmailConfirmed && email.length > 1 && <EmailNotConfirmed />} 
        {!isEmailConfirmed && email.length === 0 && <LoadingIndicator text={t("loading")}/>}
      </CabinetLayout>
    </>
  );
}

export default Cabinet;
